import selectInsurance from 'utils/selectInsurance';
import getPatientName from 'utils/print/getPatientName';

const getInsuranceInsuredsName = ({ patient, insurance, value, blankSelf = false, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  const selectedInsuranceRelationToInsured = selectedInsurance
    ? selectedInsurance['Relation to Insured']
    : 'none';
  switch (selectedInsuranceRelationToInsured) {
    case 'Self':
    case 'Employee':
      const name = getPatientName({
        ...otherProps,
        patient,
        insurance,
      });
      return (blankSelf && selectedInsurance && selectedInsurance['Relation to Insured'] === 'Self')
        ? '' : name;
    case 'Spouse':
    case 'Child':
    case 'Other':
      return selectedInsurance['Related First Name'] && selectedInsurance['Related Last Name']
        ? `${selectedInsurance['Related First Name']} ${selectedInsurance['Related Last Name']}`
        : null;
    default:
      return null;
  }
};

export default getInsuranceInsuredsName;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsName.js